import React from "react";
import Modal from "react-modal";
import SchedulePlanner from "../scheduler";

interface InputProps {
  isOpen: boolean;
  id: string;
  planning: any;
  scheduleData?: any;
  closePopup: () => void;
}

const SchedulePopup: React.FC<InputProps> = ({
  isOpen,
  id,
  planning,
  scheduleData,
  closePopup,
}) => {
  return (
    <Modal isOpen={isOpen} onRequestClose={closePopup} style={modalStyles}>
      <div className="w-[350px] sm:min-w-[800px] lg:min-w-[1000px] max-w-[screen]">
        <SchedulePlanner
          key={id}
          readOnly={true}
          isOldSchedule={planning === undefined ? true : false}
          schedule={planning ? planning : scheduleData}
          isPopup={true}
          closePopup={closePopup}
        ></SchedulePlanner>
      </div>
    </Modal>
  );
};

const modalStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    borderRadius: "24px",
    border: "1px solid var(--Primary-Gray-100, rgba(245, 245, 245, 1))",
    transform: "translate(-50%, -50%)",
    boxShadow: "0px 12px 16px -4px rgba(0, 0, 0, 0.1)",
    backgroundColor: "var(--Primary-Gray-50)",
    // margin: "20px",
    padding: "0",
  },
  overlay: {
    backgroundColor: "rgba(0, 0, 0, 0.2)",
    zIndex: "9999",
  },
};

export default SchedulePopup;
